import { useState } from "react";
import { faqItems } from "@/mocks/mirrorData";

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100/60 py-16 md:py-24">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-sm text-secondary-900">
            <i className="ri-question-line" /> 常见问题
          </span>
          <h2 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">你可能会问</h2>
          <p className="mt-4 text-base leading-7 text-foreground-600">
            关于镜像与备用地址的常见疑问，这里一次性说清楚。
          </p>
        </div>
        <div className="mt-10 space-y-3">
          {faqItems.map((f, i) => (
            <div
              key={f.id}
              className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <button
                type="button"
                onClick={() => setOpen(open === i ? -1 : i)}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
              >
                <span className="text-sm font-medium text-foreground-950 md:text-base">{f.q}</span>
                <span
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-foreground-600 transition ${
                    open === i ? "bg-primary-100 text-primary-600" : "bg-background-100"
                  }`}
                >
                  <i className={open === i ? "ri-subtract-line" : "ri-add-line"} />
                </span>
              </button>
              {open === i && (
                <div className="border-t border-background-200 px-5 py-4 text-sm leading-7 text-foreground-600">
                  {f.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}